export default {
  sections: {
    payment: 'Zahlung',
  },
  labels: {
    proceed_to_payment: 'Weiter zur Zahlung über den Link oder scannen Sie den QR-Code',
  },
  buttons: {
    generate_new_link: 'Neuen Link generieren',
    copy_link: 'Link kopieren',
    pay_now: 'Jetzt bezahlen',
  },
  toasts: {
    failed_to_create_payment_link: 'Zahlungslink konnte nicht geladen werden',
  },
};
